module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "sl-header"
  }, [_c('slider-mini', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMiniMenu),
      expression: "showMiniMenu"
    }],
    attrs: {
      "showMiniMenu": _vm.showMiniMenu
    },
    on: {
      "update:showMiniMenu": function($event) {
        _vm.showMiniMenu = $event
      }
    }
  }), _vm._v(" "), (_vm.showMiniMenu) ? _c('div', {
    staticClass: "sl-mini-sidebar-mask",
    on: {
      "click": function($event) {
        _vm.showMiniMenu = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sl-menu-icon",
    on: {
      "click": function($event) {
        _vm.showMiniMenu = true;
        _vm.$ga.event('Button', 'showMiniMenu', 'Navigator')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sl-header-logo"
  }, [_c('img', {
    attrs: {
      "src": ("/static/" + (_vm.$store.state.theme.name) + "/logo_login.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sl-path-title"
  }, [_vm._v(" " + _vm._s(_vm.$store.state.nav.navtitle) + " ")]), _vm._v(" "), _c('el-popover', {
    ref: "setting",
    attrs: {
      "popper-class": "sl-el-pop",
      "placement": "bottom",
      "width": "140",
      "trigger": "click"
    },
    model: {
      value: (_vm.settingPopoverVisible),
      callback: function($$v) {
        _vm.settingPopoverVisible = $$v
      },
      expression: "settingPopoverVisible"
    }
  }, _vm._l((_vm.$store.state.user.setting.children), function(it) {
    return _c('div', {
      staticClass: "sl-setting-item",
      class: {
        'sl-setting-item-active': _vm.$route.path === it.url
      }
    }, [_c('router-link', {
      staticClass: "sl-user-li",
      attrs: {
        "tag": "div",
        "to": {
          path: ("" + (it.url))
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.settingPopoverVisible = false
        }
      }
    }, [_c('i', {
      staticClass: "sl-icon-spot",
      class: {
        'sl-icon-spot-cell': _vm.$store.state.userAgent.isPhone
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(it.name))])])], 1)
  })), _vm._v(" "), _c('el-popover', {
    ref: "user",
    attrs: {
      "popper-class": "sl-el-pop",
      "placement": "bottom",
      "width": "140",
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "sl-setting-item"
  }, [_c('div', {
    staticClass: "sl-user-li",
    on: {
      "click": _vm.onSignOut
    }
  }, [_c('i', {
    staticClass: "sl-icon-spot",
    class: {
      'sl-icon-spot-cell': _vm.$store.state.userAgent.isPhone
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Navigator.signOut')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "sl-right-icons"
  }, [_c('ul', [(_vm.$store.state.theme.companyInfo.international) ? _c('li', {
    staticClass: "language",
    on: {
      "click": function($event) {
        _vm.dialogVisible = true;
        _vm.$ga.event('Button', 'Show Change Language Icon', 'Navigator')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "qrcode",
    class: {
      'sl-setting-active': _vm.$route.path === '/settings/qrcode'
    },
    attrs: {
      "to": {
        path: '/settings/qrcode'
      },
      "tag": "li"
    }
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "popover",
      rawName: "v-popover:setting",
      arg: "setting"
    }],
    staticClass: "setting",
    class: {
      'sl-setting-active': _vm.settingActive
    }
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "popover",
      rawName: "v-popover:user",
      arg: "user"
    }],
    staticClass: "user"
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialogVisible),
      expression: "dialogVisible"
    }],
    staticClass: "sl-mask"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.changeLoading),
      expression: "!changeLoading"
    }],
    staticClass: "sl-lang"
  }, [_c('i', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('p', {
    staticClass: "sl-item",
    class: {
      'sl-lang-active': _vm.$store.state.user.userinfo.lang === 'en'
    },
    attrs: {
      "type": "text",
      "plain": true
    },
    on: {
      "click": function($event) {
        _vm.onChange('en')
      }
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('p', {
    staticClass: "sl-item",
    class: {
      'sl-lang-active': _vm.$store.state.user.userinfo.lang === 'th'
    },
    attrs: {
      "type": "text",
      "plain": true
    },
    on: {
      "click": function($event) {
        _vm.onChange('th')
      }
    }
  }, [_vm._v("ภาษาไทย")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeLoading),
      expression: "changeLoading"
    }],
    staticClass: "sl-lang"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Navigator.changeLang')))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60eaa688!./~/vue-loader/lib/selector.js?type=template&index=0!./src/NaviBar.vue
// module id = 1113
// module chunks = 1